// src/Component/Toast/AppToast.js
import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const DEFAULT_STYLE = { marginTop: '60px', fontSize: '14px' };

const AppToast = ({ type, message, show, onClose, delay, style }) => {
  const [toastDisplayed, setToastDisplayed] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (message && show && !toastDisplayed) {
      /* istanbul ignore next -- defensive: effect cleanup always nulls the ref before a re-run */
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        toast[type](message, {
          autoClose: false,
          closeOnClick: true,
          onClose,
        });
        setToastDisplayed(true);
      }, delay);
    }

    if (!show) {
      toast.dismiss();
      setToastDisplayed(false);

      /* istanbul ignore next -- defensive: effect cleanup always nulls the ref before a re-run */
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [message, show, toastDisplayed, onClose, type, delay]);

  return (
    <ToastContainer
      className="custom-toast"
      position="top-right"
      hideProgressBar={false}
      newestOnTop={false}
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover={false}
      style={style}
    />
  );
};

AppToast.propTypes = {
  type: PropTypes.oneOf(['success', 'error', 'info', 'warning']).isRequired,
  message: PropTypes.string,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  delay: PropTypes.number,
  style: PropTypes.object,
};

AppToast.defaultProps = {
  message: '',
  onClose: () => {},
  delay: 0,
  style: DEFAULT_STYLE,
};

export default AppToast;